import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlay } = FiIcons;

const WhatWeDo = () => {
  return (
    <section className="gradient-bg text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold mb-8">What We Do</h2>
          <div className="flex justify-center space-x-8 text-sm">
            <span className="border-b-2 border-orange-500 pb-2">ABOUT US</span>
            <span className="text-blue-200 hover:text-white cursor-pointer">OUR SERVICES</span>
            <span className="text-blue-200 hover:text-white cursor-pointer">OUR HISTORY</span>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img 
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=500&h=400&fit=crop&crop=center"
              alt="Modern Office Building"
              className="w-full h-auto rounded-lg shadow-xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-bold">SEO & Marketing</h3>
            <p className="text-blue-100 leading-relaxed">
              This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.
            </p>
            <p className="text-blue-100 leading-relaxed">
              This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.
            </p>
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center space-x-3 bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg transition-colors"
            >
              <SafeIcon icon={FiPlay} className="w-5 h-5" />
              <span className="font-medium">WATCH VIDEO</span>
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;